module.exports = __webpack_public_path__ + "img/dni.210d3d2a.svg";